import { Box, Wrap, WrapItem } from '@chakra-ui/react'

import UserVolunteerRoleQ from '@/queries/UserVolunteerRoleQ'
import type { Query } from '@/client/query'
import type { AchievementId, UserProgression } from '@/client/services/progression'

import AchievementBadgeDetail from './AchievementBadgeDetail'
import VolunteerRoleBadgeDetail from './VolunteerRoleBadgeDetail'

export default function BadgeList({
  achievementIds,
  userVolunteerRoles,
  progression,
  limit = null,
}: {
  achievementIds: AchievementId[]
  userVolunteerRoles: Query[]
  progression: Partial<UserProgression>
  limit?: number | null
}): React.ReactElement {
  return achievementIds.length + userVolunteerRoles.length === 0 ? (
    <Box>No badges here yet!</Box>
  ) : (
    <Wrap spacing="12px" gridAutoRows="1fr">
      {userVolunteerRoles.slice(0, limit ?? undefined).map(userVolunteerRole => (
        <WrapItem key={userVolunteerRole(UserVolunteerRoleQ.id) ?? 0}>
          <VolunteerRoleBadgeDetail userVolunteerRole={userVolunteerRole} />
        </WrapItem>
      ))}
      {achievementIds
        .slice(0, limit == null ? undefined : Math.max(0, limit - userVolunteerRoles.length))
        .map(achievementId => (
          <WrapItem key={achievementId}>
            <AchievementBadgeDetail
              achievementId={achievementId}
              key={achievementId}
              progression={progression}
            />
          </WrapItem>
        ))}
    </Wrap>
  )
}
